import AppMarker, { AppMarkerProps } from 'components/AppMarker'
import SvgStatCircle, { SvgStatCircleProps } from 'components/SvgStatCircle'
import useSvgDataUri from 'hooks/useSvgDataUri'
import React, { CSSProperties, useMemo } from 'react'
import { theme } from 'styled'

export type AppMarkerStatProps = Omit<AppMarkerProps, 'assetId'> &
  SvgStatCircleProps

const AppMarkerStat = ({
  error,
  label,
  total,
  warning,
  galvanized,
  ...rest
}: AppMarkerStatProps) => {
  const { ref, uri } = useSvgDataUri()

  const size = 54

  const icon = useMemo<undefined | google.maps.Icon>(() => {
    if (!uri) {
      return
    }

    return {
      anchor: new google.maps.Point(size / 2, size / 2),
      scaledSize: {
        height: size,
        width: size,
        equals: other => other.width === other.height
      },
      url: uri
    }
  }, [uri])

  const markerLabel = useMemo<undefined | google.maps.MarkerLabel>(() => {
    if (!label) {
      return
    }

    if (typeof label !== 'string') {
      return label
    }

    return {
      color: theme.colors.black,
      fontFamily: 'Lato, "Helvetica Neue", Arial, Helvetica, sans-serif',
      fontSize: '12px',
      fontWeight: '700',
      text: label
    }
  }, [label])

  return (
    <>
      <SvgStatCircle
        error={error}
        ref={ref}
        style={svgStyle}
        total={total}
        warning={warning}
        galvanized={galvanized}
      />
      <AppMarker assetId="unknown" icon={icon} label={markerLabel} {...rest} />
    </>
  )
}

const svgStyle: CSSProperties = {
  borderRadius: '50%'
}

export default AppMarkerStat
